//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------


export const handleListFavouriteVideo = (data) => async (dispatch) => {
    try {
        const { user_id, type } = data;
        
        if (!user_id) {
            console.error('handleListFavouriteVideo: No user_id available');
            return;
        }
        
        if (!type) {
            console.error('handleListFavouriteVideo: No type provided');
            return;
        }

        const video = await apis.post('favourite_video', `/list`, {
            body: data
        });
        if (video) {
            await dispatch(Actions.listFavouriteVideo(video));
        }
        return video;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing favourite video',
                error,
                module: 'FAVOURITE_VIDEO',
                operation: 'LIST_FAVOURITE_VIDEO'
            });
        }
    }
};

export const handleCreateFavouriteVideo = (data) => async (dispatch) => {
    try {
        const { user_id } = data;
        
        if (!user_id) {
            console.error('handleCreateFavouriteVideo: No user_id available');
            return;
        }
        const videos = await apis.post('favourite_video', `/create`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.updateFavouriteVideo(videos));
        } else {
            await dispatch(Actions.createFavouriteVideo(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating favourite video',
                error,
                module: 'FAVOURITE_VIDEO',
                operation: 'CREATE_FAVOURITE_VIDEO'
            });
        }
    }
};

export const handleListMostUsedVideo = () => async (dispatch) => {
    try {
        const response = await apis.get('favourite_video', `/mostUsedVideo`);
        if (response) {
            // await dispatch(Actions.listOfMostUsedVideo(response));
        }
        return response[0];
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing most used video',
                error,
                module: 'FAVOURITE_VIDEO',
                operation: 'LIST_MESSAGE_USER_VIDEO'
            });
        }
    }

    
};

export const handleListMostUsedEbookById = (id) => async (dispatch) => {
    try {
        const response = await apis.get('favourite_video', `/mostUsedEbook/${id}`);
        if (response) {
            // await dispatch(Actions.listOfMostUsedVideo(response));
            const data = response?.data;
            return data; 
        }
            
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing most used ebook by id',
                error,
                module: 'FAVOURITE_VIDEO',
                operation: 'LIST_MESSAGE_USER_EXAM_BOOK_INSTRUCTION'
            });
        }
    }

    
};